module.exports = __webpack_public_path__ + "static/media/informalwhite.e4593df4.svg";